export default __webpack_public_path__ + "static/olive-wide-one-a8fc083a53c4560a5757a05b2e3a4526.jpg";